export class MarkAsDirty {
    static readonly type = '[Editor.Transform] Mark as Dirty';
}
